const attr = {
  width: '0.8em',
  height: '0.6em',
  viewBox: '0 0 16 16',
  fill: '#343a40',
  xmlns: 'http://www.w3.org/2000/svg',
  class: 'bi bi-paperclip mb-3'
}

function createSvgAttribute (updating) {
  return Object.assign({}, attr, updating)
}

export default createSvgAttribute



// WEBPACK FOOTER //
// ./src/components/ui-component/util/error-code/createSvgAttr.js